import { Box, TableCell } from "@mui/material";
import StyledTableRow from "../../../../components/table/styled-table-row";
import { ProductAndBatchId, ProductBatch, ProductBatchRequest } from "../../../../service/model/store.model";
import { useState } from "react";
import ProductBatchForm from "./product-batch-form";
import { ConfirmationDialog } from "../../../../components/confiramation-dialog";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { selectLoggedInUser } from "../../../auth/auth.slice";
import TableActionButton from "../../../../components/table/table-action-button";
import { deleteBatch, updateBatch } from "../product-batch.slice";
import { getCurrentDate } from "../../../../shared/utils";
import { EditIcon, DeleteIcon } from "../../../../shared/icons";

interface TableRowProps {
    readonly productBatch: ProductBatch
}

const ProductBatchTableRow: React.FC<TableRowProps> = ({ productBatch }) => {
    const dispatch = useAppDispatch();
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [showProductBatchForm, setShowProductBatchForm] = useState(false);
    const loggedInUserDetails = useAppSelector(selectLoggedInUser);
    const loggedInUser = loggedInUserDetails?.user;
 
    const handleDelete = () => {
        dispatch(deleteBatch({productId: productBatch.productId, batchId: productBatch.id} as ProductAndBatchId))
        setShowDeleteDialog(false)
    }

    const handleDeleteCancel = () => {
        setShowDeleteDialog(false)
    }

    const handleSubmit = (data: ProductBatchRequest) => {
        loggedInUser && dispatch(updateBatch({ ...data, id: productBatch.id, productId: productBatch.productId })).then(resp => {
            if (resp.meta.requestStatus === 'fulfilled') {
                setShowProductBatchForm(false);
            }
        });
    };

    return (
        <>
            <StyledTableRow key={productBatch.id}>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Received On</Box>{productBatch.receivedDate}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Batch Code</Box>{productBatch.batchCode}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Unit Cost</Box>{productBatch.costPrice}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Selling Price</Box>{productBatch.sellingPrice}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Quantity Received</Box>{productBatch.quantityReceived}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Stock Available</Box>{productBatch.quantityInStock}</TableCell>
                <TableCell  sx={{color: productBatch.expiryDate < getCurrentDate() ? 'red' : ''}}><Box component="div" display="inline" className="responsive-mobile-heading">Expiry Date</Box>{productBatch.expiryDate}</TableCell>
                <TableCell>
                    <Box component="div" display="inline" className="responsive-mobile-heading">Actions</Box>
                    <TableActionButton onClick={() => setShowProductBatchForm(true)} label="Edit" icon={<EditIcon />} />
                    <TableActionButton onClick={() => setShowDeleteDialog(true)} label="Delete" icon={<DeleteIcon />} />
                </TableCell>
            </StyledTableRow>
            {showProductBatchForm &&
                <ProductBatchForm productBatch={productBatch} editable={true} onClose={() => setShowProductBatchForm(false)} onSubmit={handleSubmit} />
            }
            {showDeleteDialog &&
                <ConfirmationDialog show={true} message="Are you sure you want to delete?" onConfirm={handleDelete} onCancel={handleDeleteCancel} />
            }
        </>
    );
}

export default ProductBatchTableRow;